export const activitiesDefault = [
  {
    'taxonomy': -1,
    'name': 'Inget Loggat',
    'name_EN': 'Nothing Logged',
    'category': 'Inget Loggat',
    'subCategory': 'Inget Loggat',
    'keywords': ['Inget Loggat'],
    'frequency': 0,
    'quickSelection': false,
  },
  // EGENOMSORG
  {
    'taxonomy': 20,
    'name': 'Måltid',
    'name_EN': 'Meal',
    'category': 'Egenomsorg',
    'subCategory': 'Äta',
    'keywords': ['Måltid', 'Äta', 'Käka', 'Mat'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 30,
    'name': 'Frukost',
    'name_EN': 'Breakfast',
    'category': 'Egenomsorg',
    'subCategory': 'Äta',
    'keywords': ['Frukost', 'Äta', 'Käka', 'Mat', 'Morgon'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 40,
    'name': 'Lunch',
    'name_EN': 'Lunch',
    'category': 'Egenomsorg',
    'subCategory': 'Äta',
    'keywords': ['Lunch', 'Äta', 'Käka', 'Mat'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 50,
    'name': 'Mellanmål',
    'name_EN': 'Snack',
    'category': 'Egenomsorg',
    'subCategory': 'Äta',
    'keywords': ['Mellanmål', 'Äta', 'Käka', 'Mat', 'Eftermiddag'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 60,
    'name': 'Middag',
    'name_EN': 'Dinner',
    'category': 'Egenomsorg',
    'subCategory': 'Äta',
    'keywords': ['Middag', 'Äta', 'Käka', 'Mat'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 70,
    'name': 'Kvällsmat',
    'name_EN': 'Supper',
    'category': 'Egenomsorg',
    'subCategory': 'Äta',
    'keywords': ['Kvällsmat', 'Äta', 'Käka', 'Mat', 'Kväll'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 80,
    'name': 'Festa på vin/öl/sprit',
    'name_EN': 'Party on alcohol',
    'category': 'Egenomsorg',
    'subCategory': 'Äta',
    'keywords': ['Fest', 'Festa', 'Alkohol', 'Vin', 'Öl', 'Sprit', 'Party'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 110,
    'name': 'Kaffe/te-fika',
    'name_EN': 'Coffe/Tea',
    'category': 'Egenomsorg',
    'subCategory': 'Äta',
    'keywords': ['Kaffe', 'Te', 'Fika'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 160,
    'name': 'Sova',
    'name_EN': 'Sleep',
    'category': 'Egenomsorg',
    'subCategory': 'Sömn',
    'keywords': ['Sova', 'Sömn', 'Natt', 'Drömma'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 170,
    'name': 'Vaken i sängen',
    'name_EN': 'Awake in bed',
    'category': 'Egenomsorg',
    'subCategory': 'Sömn',
    'keywords': ['Vaken', 'Sova', 'Sömnlös', 'Kan inte sova', 'Säng'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 180,
    'name': 'Vila',
    'name_EN': 'Rest',
    'category': 'Egenomsorg',
    'subCategory': 'Sömn',
    'keywords': ['Vila', 'Vilar', 'Slappa'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 200,
    'name': 'Duscha/bada',
    'name_EN': 'Shower/bath',
    'category': 'Egenomsorg',
    'subCategory': 'Hygien',
    'keywords': ['Duscha', 'Dusch', 'Bada', 'Bad', 'Badda', 'Tvätta sig'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 210,
    'name': 'Toalett',
    'name_EN': 'Toilet',
    'category': 'Egenomsorg',
    'subCategory': 'Hygien',
    'keywords': ['Toalett', 'Wc', 'Kissa', 'Bajsa', 'Toa', 'Dass'],
    'frequency': 0,
    'quickSelection': false,
  },
  // FÖRFLYTTNING
  {
    'taxonomy': 300,
    'name': 'Förflyttning',
    'name_EN': 'Movement',
    'category': 'Förflyttning',
    'subCategory': 'Förflyttning',
    'keywords': ['Förflytta', 'Röra på sig', 'Gå', 'Promenad'],
    'frequency': 0,
    'quickSelection': false,
  },
  // ARBETE/SKOLA
  {
    'taxonomy': 400,
    'name': 'Arbeta',
    'name_EN': 'Work',
    'category': 'Arbete/skola',
    'subCategory': 'Arbete',
    'keywords': ['Arbeta', 'Arbete', 'Jobb', 'Jobba'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 410,
    'name': 'Skola/utbildning',
    'name_EN': 'School/education',
    'category': 'Arbete/skola',
    'subCategory': 'Skola',
    'keywords': ['Skola', 'Utbildning', 'Studera', 'Plugga', 'Lektioner'],
    'frequency': 0,
    'quickSelection': false,
  },
  // AVKOPPLING
  {
    'taxonomy': 500,
    'name': 'Titta på TV',
    'name_EN': 'Watch TV',
    'category': 'Avkoppling',
    'subCategory': 'Media',
    'keywords': ['TV', 'Television', 'Titta', 'Film', 'Serie'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 510,
    'name': 'Lyssna på musik/podcast',
    'name_EN': 'Listen to music/podcast',
    'category': 'Avkoppling',
    'subCategory': 'Media',
    'keywords': ['Musik', 'Lyssna', 'Podcast', 'Radio'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 520,
    'name': 'Läsa bok/tidning',
    'name_EN': 'Read book/newspaper',
    'category': 'Avkoppling',
    'subCategory': 'Media',
    'keywords': ['Läsa', 'Bok', 'Tidning', 'Magazine'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 530,
    'name': 'Spela dator/TV-spel',
    'name_EN': 'Play computer/video games',
    'category': 'Avkoppling',
    'subCategory': 'Media',
    'keywords': ['Spela', 'Datorspel', 'TV-spel', 'Gaming', 'Datorn'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 540,
    'name': 'Surfa på nätet',
    'name_EN': 'Browse the internet',
    'category': 'Avkoppling',
    'subCategory': 'Media',
    'keywords': ['Surfa', 'Internet', 'Webb', 'Nätet', 'Browser'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 550,
    'name': 'Sociala medier',
    'name_EN': 'Social media',
    'category': 'Avkoppling',
    'subCategory': 'Media',
    'keywords': ['Sociala medier', 'Facebook', 'Instagram', 'Twitter', 'Snapchat'],
    'frequency': 0,
    'quickSelection': false,
  },
  // HEMVÅRD
  {
    'taxonomy': 600,
    'name': 'Städa',
    'name_EN': 'Clean',
    'category': 'Hemvård',
    'subCategory': 'Hushåll',
    'keywords': ['Städa', 'Städning', 'Rensa', 'Damma'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 610,
    'name': 'Tvätta kläder',
    'name_EN': 'Do laundry',
    'category': 'Hemvård',
    'subCategory': 'Hushåll',
    'keywords': ['Tvätta', 'Tvätt', 'Kläder', 'Disk'],
    'frequency': 0,
    'quickSelection': false,
  },
  // FIXA MAT
  {
    'taxonomy': 700,
    'name': 'Laga mat',
    'name_EN': 'Cook',
    'category': 'Fixa mat',
    'subCategory': 'Matlagning',
    'keywords': ['Laga mat', 'Laga', 'Koka', 'Matlagning'],
    'frequency': 0,
    'quickSelection': false,
  },
  {
    'taxonomy': 710,
    'name': 'Handla mat',
    'name_EN': 'Shop for food',
    'category': 'Fixa mat',
    'subCategory': 'Matlagning',
    'keywords': ['Handla', 'Mataffär', 'Inköp', 'Shopping'],
    'frequency': 0,
    'quickSelection': false,
  },
  // OMVÅRDNAD
  {
    'taxonomy': 800,
    'name': 'Ta hand om andra',
    'name_EN': 'Take care of others',
    'category': 'Omvårdnad',
    'subCategory': 'Omvårdnad',
    'keywords': ['Ta hand om', 'Vårda', 'Hjälpa', 'Stötta'],
    'frequency': 0,
    'quickSelection': false,
  },
];
